module.exports = __webpack_public_path__ + "static/media/fire-ball-gray.91adb85c.svg";